import React, { Component } from "react";
import { ToastNotification, TOAST_TYPE, showToast } from "@acadia-ui/toast";
import Modal, { MODAL_SIZE } from "@acadia-ui/modal";
import Loading from "@acadia-ui/loading";
import Dropdown from "@acadia-ui/dropdown";
import Button, { BUTTON_DISPLAY } from "@acadia-ui/button";
import { AccordionControl, AccordionContent } from "@acadia-ui/accordion";
import BookFiltersStore from "../../Flux/Stores/BookFiltersStore";
import _ from "lodash";
import { getPlatformAdvertisersGeneric, AddCampaignToGCM, GCMPostPushHandling, getCampaignFinancialSettings } from "../../Flux/Actions/MasterCampaignActions";

import "./modal.scss";
import "./pushToPlatformCampaignModal.scss";

const FINANCIAL_SETTINGS_MAPPING = {
	PrismaProductValue: { dropdownName: "Prisma Product", optionsName: "PrismaProductOptions", multiple: false },
	PrismaMediaCodeValue: { dropdownName: "Prisma Media Code", optionsName: "PrismaMediaCodeOptions", multiple: false },
	PrismaClientCodeValue: { dropdownName: "Prisma Client Code", optionsName: "PrismaClientCodeoptions", multiple: false },
	PrismaBuyTypeValue: { dropdownName: "Prisma Buy Type", optionsName: "PrismaBuyTypeOptions", multiple: true }
};

const FINANCIAL_SETTINGS_ORDER = {
	PrismaMediaCodeValue: 0,
	PrismaClientCodeValue: 1,
	PrismaProductValue: 2,
	PrismaBuyTypeValue: 3
};

const EMPTY_FINANCIAL_SETTING = {
	PrismaProductValue: {
		value: null,
		disableDelete: false,
		disableField: false
	},
	PrismaMediaCodeValue: {
		value: null,
		disableDelete: false,
		disableField: false
	},
	PrismaClientCodeValue: {
		value: null,
		disableDelete: false,
		disableField: false
	},
	PrismaBuyTypeValue: {
		value: null,
		disableDelete: false,
		disableField: false
	}
};

const SINGLE_SELECT_FINANCIAL_SETTINGS = ["PrismaClientCodeValue", "PrismaMediaCodeValue", "PrismaProductValue"];
const MULTI_SELECT_FINANCIAL_SETTING = "PrismaBuyTypeValue";

class PushToPlatformCampaignModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			advertiser: null,
			financialSettingOptions: {},
			financialSettings: [_.cloneDeep(EMPTY_FINANCIAL_SETTING)],
			open: false,
			loading: true,
			disableDropdown: false
		};
	}

	componentDidMount() {
		this.props.pushToPlatformCampaignModal(this);
	}

	componentWillUnmount() {
		this.props.pushToPlatformCampaignModal(undefined);
	}

	setAdvertisers = (response, defaultSelectedId) => {
		const matchingAdvertiser = response.PlatformAdvertisers?.find(({ value }) => value == defaultSelectedId);
		this.setState(
			{
				advertisers: response.PlatformAdvertisers,
				financialSettingOptions: response.FinancialSettings,
				loading: Boolean(this.state.masterPlatformID === 5 && Boolean(matchingAdvertiser)),
				advertiser: matchingAdvertiser,
				disableDropdown:
					(Boolean(matchingAdvertiser) && (this.props?.selectedCampaignInfo?.status == "3" || matchingAdvertiser.isPrismaMultiple === true)) ||
					(this.props?.selectedCampaignInfo?.platformId == 5 && Boolean(this.props?.selectedCampaignInfo?.advertiserId))
			},
			() => {
				if (this.state.masterPlatformID === 5 && Boolean(matchingAdvertiser)) {
					getCampaignFinancialSettings(this.state.campaignID).then((res) => {
						if (res.length) {
							try {
								const { financialSettingOptions } = this.state;
								const savedFinancialSettings = JSON.parse(res[0].FinancialSettings);
								const financialSettings = [];
								savedFinancialSettings.forEach((savedSetting) => {
									const settingWithMatchingValues = financialSettings.find((setting) => {
										return SINGLE_SELECT_FINANCIAL_SETTINGS.every(
											(settingValueName) => setting[settingValueName]?.value?.value === savedSetting[settingValueName]
										);
									});
									if (settingWithMatchingValues) {
										settingWithMatchingValues[MULTI_SELECT_FINANCIAL_SETTING].value.push({
											label: savedSetting[MULTI_SELECT_FINANCIAL_SETTING],
											value: savedSetting[MULTI_SELECT_FINANCIAL_SETTING]
										});
									} else {
										const savedSettingObj = {};
										Object.keys(savedSetting).forEach((valueName) => {
											const dataKeyOptions = financialSettingOptions[FINANCIAL_SETTINGS_MAPPING[valueName].optionsName];
											let matchingOption = null;
											if (!FINANCIAL_SETTINGS_MAPPING[valueName].multiple) {
												matchingOption = dataKeyOptions?.find((dataValue) => {
													return dataValue.value === savedSetting[valueName];
												}) || { label: savedSetting[valueName], value: savedSetting[valueName] };
											} else {
												const arrayOfSavedValues = savedSetting[valueName].split(",");
												matchingOption = arrayOfSavedValues.map((savedValue) => {
													return (
														dataKeyOptions?.find((dataValue) => {
															return dataValue.value === savedValue;
														}) || { label: savedValue, value: savedValue }
													);
												});
											}
											savedSettingObj[valueName] = { value: matchingOption, disableDelete: true, disableField: valueName !== "PrismaBuyTypeValue" };
										});
										financialSettings.push(savedSettingObj);
									}
								});
								this.setState({ financialSettings });
							} catch (e) {
								console.log("Failed to parse saved financial settings", e);
							}
						} else {
							this.setState({ financialSettings: [] });
						}
						this.setState({ loading: false });
					});
				}
			}
		);
	};

	triggerOpenClose = (advertiserId, campaignID, masterPlatformID) => {
		try {
			if (!this.state.open) {
				this.setState({ masterPlatformID }, () => {
					const config = {
						masterPlatformID
					};
					getPlatformAdvertisersGeneric(config, (advertisers) => this.setAdvertisers(advertisers, advertiserId));
				});
			}
		} catch (e) {
			console.log(e);
		}

		this.setState({
			advertiser: null,
			open: !this.state.open,
			loading: true,
			campaignID,
			financialSettingOptions: {},
			financialSettings: [_.cloneDeep(EMPTY_FINANCIAL_SETTING)]
		});
	};

	handleSubmit = async (e) => {
		if (this.state.masterPlatformID !== 1) {
			e.preventDefault();
			const platformName = this.state.masterPlatformID == 5 ? "Prisma" : "DV360";
			try {
				const financialSettingsArray = [];
				if (this.state.masterPlatformID == 5 && this.checkIfAllFinancialSettingsFilled()) {
					this.state.financialSettings.forEach((setting) => {
						setting[MULTI_SELECT_FINANCIAL_SETTING]?.value?.forEach((buyType) => {
							const selectedSettings = {};
							SINGLE_SELECT_FINANCIAL_SETTINGS.forEach((optionName) => {
								selectedSettings[optionName] = setting[optionName].value.value;
							});
							selectedSettings[MULTI_SELECT_FINANCIAL_SETTING] = buyType.value;
							financialSettingsArray.push(selectedSettings);
						});
					});
				}
				await this.props.onSubmit(this.state.campaignID, this.state.advertiser.value, this.state.masterPlatformID, financialSettingsArray);

				showToast("masterCampaignToasts", <ToastNotification type={TOAST_TYPE.INFO} message={`Push to ${platformName} has been initiated`} timed={5000} />);
			} catch (error) {
				showToast("masterCampaignToasts", <ToastNotification type={TOAST_TYPE.ERROR} message={`Failed to Push Campaign to ${platformName}`} timed={5000} />);
			} finally {
				this.triggerOpenClose();
			}
		} else if (this.state.masterPlatformID == 1) {
			// The behavior for pushing to Prisma and DV360 are that the modal closes and there's no indication that anything is happening until the api call finishes.
			// I've updated the behavior for GCM to instead display a loading spinner, which hopefully provides more informative UX
			this.setState({ loading: true }, () => {
				AddCampaignToGCM(this.state.campaignID, this.state.advertiser.value)
					.then((res) => {
						GCMPostPushHandling(true);
					})
					.catch(async (error) => {
						try {
							const errorObject = await error.details.json();
							const errorMessage =
								typeof errorObject === "string" ? errorObject : typeof errorObject?.detail === "string" ? errorObject?.detail : "Failed to push campaign to GCM";
							showToast("masterCampaignToasts", <ToastNotification type={TOAST_TYPE.ERROR} message={errorMessage} />);
						} catch (e) {
							showToast("masterCampaignToasts", <ToastNotification type={TOAST_TYPE.ERROR} message={"Failed to push campaign to GCM"} />);
						}
						GCMPostPushHandling(false);
					})
					.finally(() => {
						this.props.onSubmit(this.state.campaignID, this.state.advertiser.value, this.state.masterPlatformID);
						this.triggerOpenClose();
					});
			});
		}
	};

	checkIfAnyFinancialSettingsNotSelected = () => {
		if (this.state.masterPlatformID !== 5) return false;
		// If the platform is Prisma, we want to check if any financial settings are partially selected
		return (
			!this.checkIfAllFinancialSettingsFilled() &&
			this.state.financialSettings.some((setting) => {
				return Object.values(setting).some((field) => field.value);
			})
		);
	};

	checkIfAllFinancialSettingsFilled = () => {
		return this.state.financialSettings.every((setting) => {
			return Object.values(setting).every((field) => field.value && (Array.isArray(field.value) ? field.value.length > 0 : true));
		});
	};

	render() {
		let heading;
		if (this.state.masterPlatformID == 5) {
			heading = "Push Prisma Campaign";
		} else if (this.state.masterPlatformID == 2) {
			heading = "Push DV360 Campaign";
		} else if (this.state.masterPlatformID == 1) {
			heading = "Push GCM Campaign";
		} else {
			heading = "Push Campaign";
		}

		return (
			<Modal
				id="pushToPlatformCampaignModal"
				heading={heading}
				size={MODAL_SIZE.MEDIUM}
				description="Select an advertiser for the campaign"
				isOpen={this.state.open}
				onRequestClose={() => {
					if (this.state.open) {
						this.triggerOpenClose();
					}
				}}
				actionSetProps={{
					actionsRight: (
						<>
							<Button display="text" disabled={this.state.loading} onClick={() => this.triggerOpenClose()} data-tracking-id-alt="cancel-push-to-platform">
								Cancel
							</Button>
							<Button
								display="primary"
								onClick={this.handleSubmit}
								disabled={!this.state.advertiser || this.state.loading || this.checkIfAnyFinancialSettingsNotSelected()}
								data-tracking-id-alt="confirm-push-to-platform"
							>
								Push
							</Button>
						</>
					)
				}}
				onClick={() => {}}
			>
				{this.state.loading ? (
					<Loading className="modalLoading" />
				) : (
					<div className="platform-push-modal-content">
						<Dropdown
							label="Advertiser"
							placeholder="Select an Advertiser"
							options={this.state.advertisers}
							value={this.state.advertiser}
							onChange={(value) => this.setState({ advertiser: value })}
							isDisabled={this.state.disableDropdown}
							isSearchable={true}
						/>
						{this.state.masterPlatformID == 5 &&
						Object.keys(this.state.financialSettingOptions).length &&
						(!this.props?.selectedCampaignInfo?.advertiserId || (Boolean(this.props?.selectedCampaignInfo?.advertiserId) && this.state.financialSettings.length)) ? (
							<div className="prisma-financial-settings-container">
								<div className="financial-settings-divider" />
								<h3 className="settings-header">Prisma Financial Settings</h3>
								{this.state.financialSettings.map((setting, settingIndex) => {
									const dropdowns = Object.keys(setting)
										.sort((a, b) => FINANCIAL_SETTINGS_ORDER[a] - FINANCIAL_SETTINGS_ORDER[b])
										.map((valueName) => {
											const settingMapping = FINANCIAL_SETTINGS_MAPPING[valueName];
											return (
												<Dropdown
													className="financial-settings-dropdown"
													options={this.state.financialSettingOptions[settingMapping.optionsName]}
													value={setting[valueName].value}
													isClearable
													multiple={settingMapping.multiple}
													disabled={this.props?.selectedCampaignInfo.budgetLocked || setting[valueName].disableField}
													onChange={(value) => {
														const { financialSettings } = this.state;
														financialSettings[settingIndex][valueName].value = value;
														this.setState({ financialSettings });
													}}
												>
													{settingMapping.dropdownName}
												</Dropdown>
											);
										});
									const disableDelete = Object.values(setting)[0].disableDelete === true || settingIndex === 0;
									return (
										<>
											<AccordionControl
												targetId={`financial-setting-accordion-${settingIndex}`}
												action={
													!disableDelete ? (
														<Button
															className="delete-financial-setting"
															icon="icon-delete"
															display={BUTTON_DISPLAY.ICON}
															onClick={() => {
																const { financialSettings } = this.state;
																financialSettings.splice(settingIndex, 1);
																this.setState({ financialSettings });
															}}
															data-tracking-id-alt="delete-financial-setting"
														>
															Delete
														</Button>
													) : null
												}
											>
												Financial Settings {settingIndex + 1}
											</AccordionControl>
											<AccordionContent id={`financial-setting-accordion-${settingIndex}`}>
												<div className="financial-setting">
													<div className="dropdowns-container">{dropdowns}</div>
												</div>
											</AccordionContent>
										</>
									);
								})}
								{!this.props?.selectedCampaignInfo.budgetLocked && (
									<Button
										className="add-financial-setting"
										icon="icon-add"
										display={BUTTON_DISPLAY.PRIMARY}
										onClick={() => {
											const { financialSettings } = this.state;
											financialSettings.push(_.cloneDeep(EMPTY_FINANCIAL_SETTING));
											this.setState({ financialSettings });
										}}
										disabled={!this.checkIfAllFinancialSettingsFilled()}
										data-tracking-id-alt="add-financial-setting"
									>
										Add Setting
									</Button>
								)}
							</div>
						) : (
							<></>
						)}
					</div>
				)}
				<></>
			</Modal>
		);
	}
}

export default PushToPlatformCampaignModal;
